import { ILocationLog } from '../../../common/logInterfaces';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import {SET_SHOW_SIDEBAR, SET_SHOW_HEADER, SET_BYPASS_REPORT_IMAGE} from './reducer';

export const LOG_NEW_AUDIT = 'LOG_NEW_AUDIT';
export const SET_LOADING_WITH_MESSAGE = 'SET_LOADING_WITH_MESSAGE';

export const createLocationAuditLog = (locationLog: ILocationLog) => {
  return {
    elasticIndex: locationLog.elasticIndex,
    logLevel: locationLog.logLevel,
    logCategory: locationLog.logCategory,
    value: { location: locationLog.location, reportId: locationLog.reportId },
    type: LOG_NEW_AUDIT,
  };
};

export const showLoadingWithMessage = (
  showLoading: boolean,
  message: string = 'Loading'
) => {
  return {
    type: SET_LOADING_WITH_MESSAGE,
    showLoading,
    message,
  };
};

export const setShowSidebar = (showSidebar: boolean) => {
  return {
    type: SET_SHOW_SIDEBAR,
    value: showSidebar,
  };
};

export const setShowHeader = (showHeader: boolean) => {
  return {
    type: SET_SHOW_HEADER,
    value: showHeader,
  };
};

export const setBypassReportImage = (bypassReportImage: boolean) => {
  return {
    type: SET_BYPASS_REPORT_IMAGE,
    value: bypassReportImage,
  };
};

export const applicationHeartbeat = (url: string) => {
  return async (dispatch) => {
    await Api.post(url)
      .then((result: ApiResponse<any>) => {
        console.log('Pulse check complete');
        return Promise.resolve(true);
      })
      .catch((ex) => {
        console.warn('Heartbeat failed!');
        Promise.reject(ex);
      });
  };
};
